import { render, staticRenderFns } from "./PictureGallery.vue?vue&type=template&id=071df772&scoped=true&"
import script from "./PictureGallery.vue?vue&type=script&lang=js&"
export * from "./PictureGallery.vue?vue&type=script&lang=js&"
import style0 from "./PictureGallery.vue?vue&type=style&index=0&id=071df772&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "071df772",
  null
  
)

export default component.exports